import './bml-vacancies-banner.scss';
const TEMPLATE = `
<section class="main-banner-feed fade-up">
    <div class="feed-circles-wrapper" data-animate-circles>
        <!-- Білі кола -->
        <div class="feed-circle feed-circle-extra-large"></div>
        <div class="feed-circle feed-circle-large"></div>
        <div class="feed-circle feed-circle-medium"></div>
    </div>
    <div class="container-fluid">
        <p class="news-feed-description-header" data-animate-child>Будуємо майбутнє разом</p>
        <h1 class="text-adapt-vacancy" data-animate-child data-delay="200">Приєднуйтесь до команди BML</h1>
        <div class="row">
            <div class="col-lg-6"></div>
            <div class="col-lg-6">
                <p class="paragraph-news-feed-banner" data-animate-child data-delay="400">Ми шукаємо амбітних
                    медичних спеціалістів, які прагнуть змінювати майбутнє діагностики разом із сучасною
                    лабораторією BML.</p>
            </div>
        </div>
    </div>
</section>
`;

class BmlVacanciesBanner extends HTMLElement {
    connectedCallback() { if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE; }
}
customElements.define('bml-vacancies-banner', BmlVacanciesBanner);
